import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


import { MenuComponent } from './Components/menu/menu.component';
import { BuildingChooseComponent } from './Components/building-choose/building-choose.component';
import { HeaderComponent } from './Components/header/header.component';


import { AppRoutingModule } from '../app-routing.module';
import { CustomMaterialModule } from '../custom-material/custom-material.module';
import { GlobalDataProvider } from './Models/global.model.provider';
import { ToolbarComponent } from './Components/toolbar/toolbar.component';
import { BaseComponent } from './Components/base/base.component';
import { TranslocoRootModule } from '../transloco/transloco-root.module';


@NgModule({
  declarations: [
  	MenuComponent, 
    BuildingChooseComponent, HeaderComponent, ToolbarComponent, BaseComponent,
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    FormsModule,
    CustomMaterialModule,
    TranslocoRootModule
  ],
  exports: [
  	MenuComponent, 
    BuildingChooseComponent,
    HeaderComponent,
    ToolbarComponent,
    BaseComponent
  ],
  providers: [GlobalDataProvider],
})
export class MainModule { }
